import styled from 'styled-components'
// import media from 'styled-media-query'

export const CloseIcon = styled.div`
  padding-right: 18.83px;
  cursor: pointer;
`
